import React from "react";
import aboutImg from "./photos/img2.webp"; // ✅ Replace with your image path
import "./HomeAboutSection.css";

const HomeAboutSection = () => {
  return (
    <div className="container-fluid">
      <div className="container py-5">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-lg-5 col-md-6 col-12 mb-4 mb-lg-0" style={{ minHeight: "500px" }}>
            <div className="position-relative h-100">
              <img
                className="position-absolute w-100 h-100 home-about-img"
                src={aboutImg}
                alt="About"
                style={{ objectFit: "cover", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px" }}
              />
            </div>
          </div>

          {/* Right Text Section */}
          <div className="col-lg-7 col-md-6 col-12">
            <div className="section-title position-relative mb-4">
              <h6 className="d-inline-block position-relative text-danger text-uppercase pb-2">
                About Us
              </h6>
              <h1 className="display-4">
                Nurturing Young Minds for a Brighter Future
              </h1>
            </div>
            <p>
              At K.K. Blossoms School, we believe that education is more than just textbooks—it’s about igniting curiosity, fostering creativity, and nurturing confidence in every child. Our dedicated faculty and innovative teaching methods create an environment where students don’t just learn, but truly thrive. Each child is encouraged to explore, question, and develop a love for learning that lasts a lifetime.

Beyond academics, we emphasize holistic growth through a wide range of extracurricular activities, helping students discover their passions and talents. By preparing them to face challenges with resilience and responsibility, we aim to cultivate well-rounded individuals who are ready to excel in life and grow into conscientious global citizens.
            </p>

            {/* Stats Section */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAboutSection;
